import ActionBarBadge from './ActionBarBadge';

export default ActionBarBadge;
